var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98242 18C1.98242 10.2224 1.98242 6.33189 4.39837 3.91595C6.81432 1.5 10.7031 1.5 18.4824 1.5C26.26 1.5 30.1505 1.5 32.5665 3.91595C34.9824 6.33189 34.9824 10.2207 34.9824 18C34.9824 25.7776 34.9824 29.6681 32.5665 32.0841C30.1505 34.5 26.2617 34.5 18.4824 34.5C10.7048 34.5 6.81432 34.5 4.39837 32.0841C1.98242 29.6681 1.98242 25.7793 1.98242 18Z",
    stroke: "#283B49",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4235 16.6075C15.2686 16.4441 12.6349 16.7131 11.3447 19.1004C10.0546 21.4876 11.3546 23.9721 12.1673 24.9157C12.9687 25.7988 15.5165 27.4706 18.2192 25.8382C18.8896 25.434 19.7248 25.1312 20.6713 21.9693L20.5614 9.52734C20.3783 10.8977 21.8924 14.1117 26.2007 14.492",
    stroke: "#283B49",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.77d8a1a88df3fb1bff019db8f7629599.svg";
export { ForwardRef as ReactComponent };